import {layoutTranslations} from "../services/translationKeys";
import {layoutProps} from "../services/layoutProps";
import {NextPage} from "next";
import {Fragment} from "react";
import MaintenanceMain from "../components/maintenance";

export interface IMaintenanceInfo {
    allowed_ips: string;
    is_maintenance_on: number;
    maintenance_mode_end_date: string;
    maintenance_mode_text: string
}

interface IMaintenance {
    dbName: string;
    maintenanceInfo: IMaintenanceInfo;
    cacheControlVersion: string;
    whiteLogoPath: string
}

const Maintenance: NextPage<IMaintenance> = (
    {
        dbName,
        maintenanceInfo,
        cacheControlVersion,
        whiteLogoPath
    }
) => (
    <Fragment>
        <MaintenanceMain
            dbName={dbName}
            maintenanceInfo={maintenanceInfo}
            whiteLogoPath={whiteLogoPath}
            cacheControlVersion={cacheControlVersion}
        />
    </Fragment>
);

export default Maintenance;

export async function getServerSideProps({locale, req}: any) {
    const typedReq = req as unknown as {
        m: { [key: string]: any }[],
        defaultDB: { db_name: string },
        assets: { logo_image: string },
        ipv4: string
    }
    const wrapperProps = await layoutProps({
        requestHeaders: req.headers,
        requestDbName: typedReq.defaultDB.db_name,
        requestModels: typedReq.m,
        requestLogo: typedReq.assets.logo_image,
        nextJSLocale: locale,
        translationsObject: layoutTranslations,
        ipv4: typedReq.ipv4,
    })
    const { suspendStatus, maintenanceInfo, selectedLocale } = wrapperProps;

    const whiteLogoPath = typedReq.assets.logo_image
        ? `storage/${typedReq.defaultDB.db_name}${typedReq.assets.logo_image}`
        : "/images/zegashop-white-logo.svg"

    if (String(suspendStatus) === "469") {
        return {
            redirect: { destination: '/suspend', permanent: false },
        }
    }

    if (!maintenanceInfo?.is_maintenance_on) {
        return {
            redirect: { destination: '/', permanent: false },
        }
    }

    return {
        props: {
            locale: selectedLocale,
            whiteLogoPath,
            ...wrapperProps
        },
    };
}
